/* unplugin-vue-components disabled */import script from "./select-tag-view.vue?vue&type=script&setup=true&lang=js"
export * from "./select-tag-view.vue?vue&type=script&setup=true&lang=js"

import "./select-tag-view.vue?vue&type=style&index=0&id=3123564e&lang=scss&scoped=true"
import "./select-tag-view.vue?vue&type=style&index=1&id=3123564e&lang=scss"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\work\\space-0\\fsplus-vue-workspace\\foshan-street\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3123564e"]])

export default __exports__